import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import RegisterLocation from "../views/RegisterLocation.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: 'BuscameAqui.com',
      metaTags: [
        {
          name: 'description',
          content: 'Encuentra negocios y servicios en tu ciudad, juntos con sus horarios y servicios especiales como: Pedidos online, entregas a domicio y mas.'
        },
        {
          property: 'og:description',
          content: 'Encuentra negocios y servicios en tu ciudad, juntos con sus horarios y servicios especiales como: Pedidos online, entregas a domicio y mas.'
        }
      ]
    }
  },
  {
    path: "/:state/:stateName/categorias",
    name: "categories",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "Results" */ "../views/Categories.vue")
  },
  {
    path: "/:state/:stateName/:category/:categoryName/resultados",
    name: "results",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "Results" */ "../views/ResultList.vue")
  },
  {
    path: "/:state/:stateName/sitio/:place/:placeName",
    name: "place",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "Place" */ "../views/PlaceDetails.vue")
  },
  {
    path: "/informacion-legal",
    name: "legal",
    component: () =>
        import(/* webpackChunkName: "Legal" */ "../views/Legal.vue")
  },
  {
    path: "/preguntas-frecuentes",
    name: "faq",
    component: () =>
      import(/* webpackChunkName: "FAQ" */ "../views/FAQ.vue")
  },
  {
    path: "/que-hacemos",
    name: "aboutUs",
    component: () =>
      import(/* webpackChunkName: "FAQ" */ "../views/AboutUs.vue")
  },
  {
    path: "/contactanos",
    name: "contactUs",
    component: () =>
      import(/* webpackChunkName: "FAQ" */ "../views/ContactUs.vue")
  },
  {
    path: "/registro",
    name: "register",
    component: RegisterLocation,
    meta: {
      title: 'BuscameAqui.com - Regístrate'
    }
    // component: () =>
    //   import(/* webpackChunkName: "Register" */ "../views/RegisterLocation.vue")
  }
];


const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if(nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map( (el: any) => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if(!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map( (tagDef: any) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    // We use this to track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
      // Add the meta tags to the document head.
      .forEach( (tag: any) => document.head.appendChild(tag));

  next();
});

export default router;
